import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { ShipmentEndpoint } from '../constants/shipment-endpoint';
import { ShipmentFilterName } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class ShipmentFiltersService {
  constructor(private http: WrapperHttpService) {}

  getShipmentFilters(): Observable<ShipmentFilterName[]> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Filters}`;
    return this.http.withLoading().get<ShipmentFilterName[]>(url);
  }

  updateShipmentFilters(filters: ShipmentFilterName[]): Observable<ShipmentFilterName[]> {
    const url = `${API_URL}${ShipmentEndpoint.Base}${ShipmentEndpoint.Filters}`;
    return this.http.withLoading().post<ShipmentFilterName[]>(url, filters);
  }
}
